import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import ContactButton from '../mp-components/contact-button';
import ProfileFollowButton from '../../shared/profile-follow-button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${props => (props.theme.isNotMobile
    ? `
      align-items: flex-end;
    `
    : `
      justify-content: space-between;
      padding: 8px 0;
    `
  )};
  ${props => props.theme.isOnWireSide && `
    align-items: flex-start;
  `};
  ${props => props.theme.isNotMobile && `
    > *:nth-child(2) {
      margin-top: 8px;
    }
  `};
`;

export default function Actions() {
  const {
    alt,
    profile,
    contactable,
    isOfCurrentUser,
    isProfileFollowedByCurrentUser,
    onUnfollow,
    isOnWireSide,
    followEventName,
    unfollowEventName,
    isSmallMobile,
  } = React.useContext(ThemeContext);

  if (!profile.canPostWires) {
    return null;
  }

  const followButtonProps = {
    isOnWireSide,
    isProfileFollowedByCurrentUser,
    onUnfollow,
    profileId: profile.id,
    followEventName,
    unfollowEventName,
  };
  if (isSmallMobile && alt === 'traditional') {
    followButtonProps.exp = 'eow_streamlined_micro_profile';
  }

  const contactButtonName = isOnWireSide
    ? 'profile-contact-button-on-sidebar'
    : 'profile-contact-button';

  return (
    <Container className="micro-profile-actions">
      {!isOfCurrentUser && <ProfileFollowButton {...followButtonProps} />}
      {!!contactable && <ContactButton name={contactButtonName} />}
    </Container>
  );
}
